import React, { useEffect, Fragment, useState } from "react";
import { Row, Col } from "reactstrap";
import { MODULE_API } from "../../../../apis";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Loader from "../../../../components/styled-components/loader/loader";
import { Link } from "react-router-dom";
import Trust from "../../../../assets/images/latest/Trust.png";
import Insurance from "../../../../assets/images/latest/Insurance.png";
import Networth2 from "../../../../assets/images/latest/Networth2.png";
import Vacation from "../../../../assets/images/latest/Vacation-Home.png";
import "./styles/liabilitySelect.css";
const AssetAllocationLiabilites = () => {
  const [data, setData] = useState();
  const [loading, setIsLoading] = useState(true);
  const history = useHistory();
  const [liabalities, setLiabilies] = useState([]);
  const [credits, setCredits] = useState([]);

  async function getAllAssets() {
    setIsLoading(true);
    let data = await MODULE_API.insuraceAllocation("Liabilities and Credit");
    if (data && data.liability) {
      setLiabilies(data.liability);
    }
    if (data && data.credit) {
      setCredits(data.credit);
    }
    setIsLoading(false);
  }

  function handleAssetSelect(name) {
    history.push(`/liabilities_credit_new/${name}`);
  }
  useEffect(() => {
    getAllAssets();
  }, []);

  return (
    <Fragment>
      <div className="info-form-block">
        <Row gutter={16}>
          <Col span={24}>
            <h2 className="text-center font-weight-bold mb-4">
            Select the Type of Liability
            </h2>
          </Col>
        </Row>

        {/* <Row gutter={16} type="flex" justify="center">
          <Col span={12}>
            <h2 className="text-center font-weight-bold mb-4">Liabilities</h2>
            <div className="buttons-container">
              {liabalities &&
                liabalities.map((item, index) => {
                  let className = "button-wrap";

                  return (
                    <div
                      key={index}
                      className={className}
                      onClick={() => handleAssetSelect(item.name)}
                    >
                      <div style={{ flexDirection: "column" }}>
                        <div className="col-12 mt-2">
                          <img src={item.image} height="40px" width="40px" />
                        </div>
                        <div className="col-12 mb-2 mt-2">{item.name}</div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </Col>
          <Col span={12}>
            <h2 className="text-center font-weight-bold mb-4">Credit</h2>
            <div className="buttons-container">
              {credits &&
                credits.map((item, index) => {
                  let className = "button-wrap-liability";

                  return (
                    <div
                      key={index}
                      className={className}
                      onClick={() => handleAssetSelect(item.name)}
                    >
                      <div style={{ flexDirection: "column" }}>
                        <div className="col-12 mt-2">
                          <img src={item.image} height="40px" width="40px" />
                        </div>
                        <div className="col-12 mb-2 mt-2">{item.name}</div>
                      </div>
                    </div>
                  );
                })}
            </div>
          </Col>
              </Row>*/}
      </div>

      <div className="selelctmain">
        <h3 className="selectHeading">Liabilities</h3>
        <div className="selectmain" style={{justifyContent:"flex-start"}}>
          {liabalities &&
            liabalities.map((item, index) => (
              <div
                key={index}
                onClick={() => handleAssetSelect(item.name)}
                className="selectMaincards">
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainImages">
                    <img src={item.image} height={"40px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name==="Real Estates" ? "Real Estate" : item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <h3 className="selectHeading" style={{ marginTop: "1rem" }}>
          Credit
        </h3>

        <div className="selectmain" style={{justifyContent:"flex-start"}}>
          {credits &&
            credits.map((item, index) => (
              <div
                key={index}
                onClick={() => handleAssetSelect(item.name)}
                className="selectMaincards">
                <div className="selectMaincardsInner">
                  {" "}
                  <div className="selectMainImages">
                    <img src={item.image} height={"40px"} alt={item.name} />{" "}
                  </div>
                  <div className="selectMainHeader">
                    <span className="selectheadingValue">{item.name}</span>
                  </div>
                </div>
              </div>
            ))}
        </div>
      </div>
      <Loader isLoading={loading} />
    </Fragment>
  );
};

export default AssetAllocationLiabilites;
